<template>
        <mdb-navbar class="flexible-navbar main-navbar main-app-navbar" :toggler="false"  position="top"> 
            <mdb-navbar-brand href="/" class="app-brand">
            <router-link to="/" class="text-dark"><img src="https://media.thatsliving.com/public/uploads/image-png/tl-qatar-logo-transparent.png" class="img-fluid digital-catalog-brand-logo" alt="logo"></router-link>

            </mdb-navbar-brand>
            <img src="https://media.thatsliving.com/public/uploads/image-png/maison-and-object-logo.png" class="img-fluid digital-catalog-brand-logo-two" alt="logo">
            <mdb-navbar-nav class="right-nav" right :toggler="false">

            <!--  <form class="d-flex align-items-center">
                <mdb-input type="text" class="text-white bg-light" placeholder="Search" aria-label="Search" label navInput waves waves-fixed />
            </form> -->
              <template v-if="$route.name == 'welcome'">
                <mdb-nav-item href="#" class="cart-nav" anchorClass="" @click="openFilter" title="Cart">
                  <span class="btn-container"><filter-menu/>
                  <template v-if="hasFilter">
                    <div class="has-filter">&nbsp;</div>
                  </template>
                  </span>

                 
                </mdb-nav-item>
              </template>
            <mdb-nav-item href="#" class="cart-nav" anchorClass="" @click="openScan" title="Cart">
               <span class="btn-container"><qrcode-scan/></span>
            </mdb-nav-item>
            <mdb-nav-item href="#" class="cart-nav cart-nav-cart" anchorClass="" @click="openCart" title="Cart">
                <span class="btn-container ">
                <template v-if="cart.length > 0">
                <div color="success" class="cart-count">{{cart.length}}</div>
                </template>
                <selected-icon/>
                </span>
            </mdb-nav-item>
            <template v-if="user">
            <mdb-nav-item href="#" class="cart-nav" anchorClass="" @click="fnLogout" title="Logout">
                <span class="btn-container"><arrow-right/></span>
            </mdb-nav-item>
            </template>
            <template v-else>
            <template v-if="$route.name !== 'login'">
              <mdb-nav-item href="javascript:void(0)" @click="openLogin" class="cart-nav" anchorClass="" title="Login">
                <span class="btn-container">Login</span>
              </mdb-nav-item>
              </template>
            </template>
            </mdb-navbar-nav>
        </mdb-navbar>
</template>


<script>
import {mdbInput,mdbContainer, mdbNavbar, mdbTooltip,mdbNavbarBrand, mdbNavItem, mdbNavbarNav, mdbNavbarToggler, mdbBreadcrumb, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbDropdownItem, mdbIcon, mdbBadge } from 'mdbvue'
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'Navbar',
  props: {
    page: {
      type: String
    }
  },
  components: {
    mdbInput,mdbContainer,
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbBreadcrumb,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbTooltip,
    mdbIcon,
    mdbBadge
  },
  data () {
    return {
      activePage: this.page,
      toggle: false
    }
  },

  mounted () {
    const route = this.$route;

    console.log("router",route.name);
  },
  methods: {
    ...mapActions('AuthModule',[
      'Logout'
    ]),

    fnLogout(){
      this.Logout()
    },

    openCart(){
      this.$eventBus.$emit('open-cart')
    },

    openFilter(){
        this.$eventBus.$emit('open-filter')
    },
    openScan(){
      this.$eventBus.$emit('open-scan')  
    },
    openLogin(){
      this.$router.push({ name: 'login' });
    }
  },
  computed: {
    computedPage () {
      return {
        activePage: this.page
      }
    },
    ...mapGetters('CartModule',[
            'cart',
        ]),
    ...mapGetters('AuthModule',[
            'user',
        ]),
    ...mapGetters('ProductModule',[
            'products',
        ]),
    hasFilter(){
      if(this.$route.name == 'welcome' && (this.$route.query.category || this.$route.query.term)){
        return true
      }else{
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.navbar .nav-item {
  line-height: 24px;
  font-size: 16px;
}
.navbar .dropdown-toggle {
  padding: 0 10px;
  font-size: 16px;
}

.navbar ul {
  padding: 5px 0;
}

.navbar .btn {
  font-weight: 300;
}

.navbar-collapse {
  order: 0 !important;
}

.navbar .notifications-nav .dropdown-menu {
  width: 23rem; }

.navbar-expand-lg .navbar-nav {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

.btn-transparent {
  background-color: transparent !important;
  color: #000;
  text-transform: none;
  box-shadow: none !important;
}

.btn-transparent:hover, .btn-transparent:active {
  box-shadow: none !important;
}

.main-navbar{
  padding : 0!important
}

.main-navbar ul{
  padding: 0!important;
}

.user-avatar-icon{
  padding: .5rem 1rem!important
}

.cart-nav.has-cart{
  width : 55px;
}

.my-account-nav{
  padding : 9px 10px
}

.btn-container{
    background : #000;
    color : #fff;padding : 15px;border-radius: 5px;
}

.navbar .nav-item{
    line-height : 42px!important;
}

.cart-nav-cart{
    min-width : 70px;
}
.cart-count{
    position: absolute;
    right: 9px;
    top: 0;
    background: #00c851;
    padding: 9px;
    line-height: 6px;
    border-radius: 15px;
    font-size: 12px;;
}

.has-filter{
    position: absolute;
    right: 9px;
    top: 0;
    background: #00c851;
    padding: 5px;
    line-height: 6px;
    border-radius: 15px;
    font-size: 12px;;
}
</style>
